import { useImpactChartWidths } from '../context';
import { BottomDesktop } from './desktop';
import { BottomMobile } from './mobile';

export function Bottom() {
  const { desktopMode } = useImpactChartWidths();
  return desktopMode ? <BottomDesktop /> : <BottomMobile />;
}
